import Button from '@material-ui/core/Button';
import Skeleton from '@material-ui/lab/Skeleton';
import EditIcon from '@material-ui/icons/Edit';
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';
import EventIcon from '@material-ui/icons/Event';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import { ProfileEditPhoto } from '../../../shared';
import moment from 'moment';
import locale from '../locale.json';
import { useProfileSummaryCardStyles } from './ProfileSummaryCard.styles';

type ProfileSummaryCardProps = {
  user: Record<string, any>;
  currentUser: Record<string, any>;
  setUser: (user: Record<string, any>) => void;
  loading: boolean;
  showRecrutementBtn: boolean;
  onOpenRecrutement: () => void;
};

const ProfileSummaryCard = ({
  user,
  currentUser,
  setUser,
  loading,
  showRecrutementBtn,
  onOpenRecrutement,
}: ProfileSummaryCardProps) => {
  const classes = useProfileSummaryCardStyles();

  const birthDateLabel = user?.dayOfBirth
    ? `${locale.bornOn} ${moment(user.dayOfBirth).format('DD/MM/YYYY')}`
    : '';

  return (
    <div className={classes.summaryCard}>
      <div className={classes.summaryMain}>
        <div className={classes.photoWrapper}>
          <ProfileEditPhoto
            setUser={setUser}
            user={user || {}}
            currentUser={currentUser}
            loading={loading}
          />
        </div>

        <div className={classes.summaryInfo}>
          {loading ? (
            <Skeleton variant="text" width="60%" height={48} />
          ) : (
            <h2 className={classes.userName}>
              {user?.firstname} {user?.lastname}
            </h2>
          )}

          {!loading && (
            <div className={classes.metaRow}>
              {user?.email && (
                <span className={classes.metaItem}>
                  <EmailOutlinedIcon className={classes.metaIcon} />
                  {user.email}
                </span>
              )}
              {user?.postal_code && (
                <span className={classes.metaItem}>
                  <LocationOnOutlinedIcon className={classes.metaIcon} />
                  {user.postal_code}
                </span>
              )}
              {birthDateLabel && (
                <span className={classes.metaItem}>
                  <EventIcon className={classes.metaIcon} />
                  {birthDateLabel}
                </span>
              )}
            </div>
          )}
        </div>
      </div>

      {showRecrutementBtn && (
        <Button
          className={classes.outlineButton}
          onClick={onOpenRecrutement}
          startIcon={<EditIcon className={classes.outlineButtonIcon} />}>
          <span className={classes.outlineButtonText}>{locale.recrutementButton}</span>
        </Button>
      )}
    </div>
  );
};

export default ProfileSummaryCard;
